import { Theme } from '@/theme';
import Ease from '@CS/utils/Easing';
import { Screen } from '@CS/app/App.styles';
import { AppWrapper } from '@CS/app/App.styles';
import Background from '@CS/assets/Loader/loader.png';
import styled, { css, keyframes } from 'styled-components';

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }

  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
`;

/* type LoaderAttributes = {
  overlay?: boolean;
  opacity?: number;
}; */

/* export const LoaderStyle = styled.aside(
  ({ overlay, opacity = 0.0 }: LoaderAttributes) => css`
    transform: translateX(-50%);
    max-width: ${Screen.MAX};

    position: fixed;
    display: block;

    height: 100%;
    width: 100%;

    z-index: 1;
    left: 50%;
    top: 0;

    ${overlay &&
    css`
      background-color: rgb(0 0 0 / ${opacity});
    `}
  `
); */

export const LoaderStyle = styled(AppWrapper)`
  max-width: ${Screen.MAX};
  pointer-events: all;

  position: fixed;
  display: block;

  height: 100%;
  width: 100%;

  z-index: 3;
  left: 0;
  top: 0;
`;

export const ImageStyle = styled.div`
  background-image: url('${Background}');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  pointer-events: none;
  position: absolute;

  display: block;
  height: 100%;
  width: 100%;

  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
`;

type ImageContainerAttributes = {
  width: number;
};

export const ImageContainer = styled.div(
  ({ width }: ImageContainerAttributes) => css`
    transform: translateY(-50%);

    pointer-events: none;
    position: relative;
    width: ${width}px;

    display: block;
    margin: auto;
    top: 50%;
  `
);

type SpinnerAttributes = ImageContainerAttributes & {
  color: string;
  speed: number;
};

export const SpinnerStyle = styled.div(
  ({ color, speed, width }: SpinnerAttributes) => css`
    position: absolute;

    height: ${width}px;
    width: ${width}px;
    margin: auto;

    bottom: 0;
    right: 0;
    left: 0;
    top: 0;

    &::before {
      padding-top: 100%;
      display: block;
      content: '';
    }

    svg {
      animation: ${rotate} ${speed / 1.55}s linear infinite;
      transform-origin: 50%;

      position: absolute;
      margin: auto;

      height 100%;
      width: 100%;

      bottom: 0;
      right: 0;
      left: 0;
      top: 0;
    }

    circle {
      animation: ${dash} ${speed}s ${Ease.InOut.Sine} infinite;

      stroke-dasharray: 1, 200;
      stroke-linecap: round;
      stroke-dashoffset: 0;
      stroke-width: 5px;
      stroke: ${color};
    }
  `
);

export const LoadingText = styled.span`
  font-family: ${Theme.font.family.speedeeCondensed};
  font-weight: ${Theme.font.weight.bold};

  font-size: ${Theme.rems(42)};
  color: ${Theme.color.white};
  text-transform: uppercase;

  pointer-events: none;
  line-height: normal;
  text-align: center;

  margin-top: 24px;
  display: block;
`;
